import { CalendarEventAction } from 'angular-calendar';
import { startOfDay, endOfDay } from 'date-fns';

export class CalendarEventModel {
    start: Date;
    end?: Date;
    title: string;
    color: { primary: string; secondary: string; };
    actions?: CalendarEventAction[];
    allDay?: boolean;
    cssClass?: string;
    resizable?: {
        beforeStart?: boolean;
        afterEnd?: boolean;
    };
    // draggable?: boolean;
    meta?: {
        location: string,
        notes: string
    }
    totalDays: number;
    status: string;
    leaveType: string;
    appliedDate: Date;
    backToWorkDate: Date;
    reason: string;
    requestType: string;
    leaveId: string;
    description: string;
    meetingId: string;
    startTime: string;
    endTime: string;
    clientName: string;
    rejectReason: string;
    important: boolean;
    taskDetails: object;
    notes: string;
    completed: boolean;
    deleted: boolean;
    taskId: string;
    assignees: []
    starred: boolean;
    requesterId: string;
    organizerId: string;
    meetingTitle: string;
    text: string;
    comments: [];
    owner: any;
    tags: [];
    sessionType: string;
    reporterId: string;

    /**
     * Constructor
     *
     * @param data
     */
    constructor(data?) {
        data = data || {};
        this.start = new Date(data.start) || startOfDay(new Date());
        this.end = new Date(data.end) || endOfDay(new Date());
        this.title = data.title || '';
        this.color = {
            primary: data.color && data.color.primary || '#1e90ff',
            secondary: data.color && data.color.secondary || '#D1E8FF'
        };
        // this.draggable = data.draggable || true;
        this.resizable = {
            beforeStart: data.resizable && data.resizable.beforeStart || true,
            afterEnd: data.resizable && data.resizable.afterEnd || true
        };
        this.actions = data.actions || [];
        this.allDay = data.allDay || false;
        this.cssClass = data.cssClass || '';
        this.meta = {
            location: data.meta && data.meta.location || '',
            notes: data.meta && data.meta.notes || ''
        };
        this.totalDays = data.totalDays;
        this.status = data.status;
        this.leaveType = data.leaveType;
        this.appliedDate = data.appliedDate;
        this.backToWorkDate = data.backToWorkDate;
        this.reason = data.reason;
        this.requestType = data.requestType;
        this.leaveId = data.leaveId;
        this.description = data.description;
        this.meetingId = data.meetingId;
        this.startTime = data.startTime;
        this.endTime = data.endTime;
        this.clientName = data.clientName;
        this.rejectReason = data.rejectReason;
        this.important = data.important;
        this.taskDetails = data.taskDetails;
        this.notes = data.notes;
        this.completed = data.completed;
        this.deleted = data.deleted;
        this.taskId = data.taskId;
        this.assignees = data.assignees || [];
        this.starred = data.starred;
        this.sessionType = data.sessionType;
        this.requesterId = data.requesterId;
        this.reporterId = data.reporterId;
        this.organizerId = data.organizerId;
        this.meetingTitle = data.meetingTitle;
        this.text = data.text;
        this.comments = data.comments;
        this.owner = data.owner;
        this.tags = data.tags;
    }
}
